import { forwardRef } from "react";
import { height, space, color } from "styled-system";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPipe = styled.div.withConfig({
  displayName: "pipe__StyledPipe",
  componentId: "sc-1xgmc5l-0"
})(["display:inline-block;position:relative;background:", ";margin:0 ", "px;width:1px;height:0.9em;top:-0.06em;vertical-align:middle;", " ", " ", ""], p => p.theme.colors.border.split, p => p.theme.space.sm, height, space, color);
export const Pipe = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledPipe, {
    ref: ref,
    ...rest,
    color: color
  });
});
export default Pipe;